import { sizeList } from '@/views/inHouse/newProductCheck/sizeList.js'
import { request } from '@/config/request/interceptors'
export default {
  data() {
    return {
      sizes: [],
      // 昭田测试
      options: [],
      sizeList: []
    }
  },
  methods: {
    getSizeList() {
      const list = this.sizes
      if(this.category === 'all') {
        this.sizeList = list.filter((v) => !v.isSpecial).map(v => {
          return {
            ...v,
            value: this.productMeasureDtoList?.filter(y => y.code == v.code)?.length ? this.productMeasureDtoList?.filter(y => y.code == v.code)[0].value : ''
          }
        })
      }else {
        // 旧分类配置可能晚于批次详情返回，加载完成前先显示空列表。
        const codes = this.options.find((v) => v.value === this.category)?.values?.split(',') || []
        this.sizeList = codes.map(codeItem => {
          return {
            ...(list.find(v => v.code === codeItem) ?? {}),
            value: this.productMeasureDtoList?.filter(y => y.code == codeItem)?.length ? this.productMeasureDtoList?.filter(y => y.code == codeItem)[0].value : ''
          }
        })
      }
    },
    openImage() {
      this.prewImage = this.options.find((v) => v.value === this.category)?.referenceImage
      this.dialogVisible = true
    },
    // 切换旧模式分类后更新对应测量项，分类值由 v-model 保存。
    changeSelect() {
      this.getSizeList()
    }
  },
  mounted() {
    this.sizes = sizeList.map((v) => {
      return {
        ...v,
        value: ''
      }
    })
    this.getSizeList()
    // V2 配置由新品检查页在新模式下加载，旧测量页面只加载原分类。
    request.wms.wms.measureGetCategoryConfig().then((res) => {
      // res 为分类接口响应，v 为单个旧版分类配置。
      this.options = (res.data || []).map((v) => ({
        ...v,
        label: v.name,
        value: v.key,
        values: v.value
      }))
      // 配置后到时补齐旧模式的测量项，避免详情回显丢失。
      if (!this.is3rdSpecialUser && this.category !== 'all' && !this.sizeList.length) this.getSizeList()
    })
  }
}
